import axios from 'axios';

export default axios.create({
  baseURL: `https://new.bni.agency/admin/wp-json/bni/get/`
});


// WEBPACK FOOTER //
// ./src/components/api.js